import { useRouter } from "next/router";
import Head from "next/head";
import SharedGalleryViewPage from "../../../components/GalleryViewPage/SharedGalleryViewPage";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";

const SharedGalleryPage = () => {
    const router = useRouter();
    const token = router.query.token as string;

    return (
        <>
            <Head>
                <title>Galeria - Fotop Serviços</title>
            </Head>

            <SharedGalleryViewPage token={token} />
        </>
    );
};

export default SharedGalleryPage;
